import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PlusIcon, FilterIcon, DownloadIcon, EyeIcon, EditIcon, TrashIcon, MapPinIcon, QrCodeIcon, TagIcon, UploadIcon, SearchIcon, InfoIcon, ArrowLeftIcon, CheckIcon, XIcon, BuildingIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
import ExportMenu from '../../components/ui/ExportMenu';
// Mock chain merchant data
const chainMerchantsData = [{
  id: 'CM001',
  name: 'CityMart Stores',
  businessType: 'Retail',
  taxId: 'TX-1234567',
  status: 'active',
  superMerchant: 'Global Retail Group',
  superMerchantId: 'SM001',
  storeCount: 24,
  transactionVolume: 520000,
  lastActivity: '2023-07-15T09:30:00Z',
  contactPerson: 'Alice Johnson',
  email: 'alice@citymart.com',
  phone: '+1 (555) 123-4567'
}, {
  id: 'CM002',
  name: 'HomeGoods Plus',
  businessType: 'Home Improvement',
  taxId: 'TX-7654321',
  status: 'active',
  superMerchant: 'Global Retail Group',
  superMerchantId: 'SM001',
  storeCount: 15,
  transactionVolume: 480000,
  lastActivity: '2023-07-14T15:45:00Z',
  contactPerson: 'Bob Smith',
  email: 'bob@homegoodsplus.com',
  phone: '+1 (555) 987-6543'
}, {
  id: 'CM003',
  name: 'Quick Burger Chain',
  businessType: 'Food & Beverage',
  taxId: 'TX-9876543',
  status: 'active',
  superMerchant: 'Fast Food Alliance',
  superMerchantId: 'SM002',
  storeCount: 32,
  transactionVolume: 620000,
  lastActivity: '2023-07-16T12:30:00Z',
  contactPerson: 'Carol Davis',
  email: 'carol@quickburger.com',
  phone: '+1 (555) 456-7890'
}, {
  id: 'CM004',
  name: 'Fresh Salad Bars',
  businessType: 'Food & Beverage',
  taxId: 'TX-5432198',
  status: 'active',
  superMerchant: 'Fast Food Alliance',
  superMerchantId: 'SM002',
  storeCount: 18,
  transactionVolume: 240000,
  lastActivity: '2023-07-15T11:45:00Z',
  contactPerson: 'David Wilson',
  email: 'david@freshsalad.com',
  phone: '+1 (555) 234-5678'
}, {
  id: 'CM005',
  name: 'Gadget World',
  businessType: 'Technology',
  taxId: 'TX-8765432',
  status: 'inactive',
  superMerchant: 'Tech Distribution Network',
  superMerchantId: 'SM003',
  storeCount: 8,
  transactionVolume: 320000,
  lastActivity: '2023-06-28T14:30:00Z',
  contactPerson: 'Eva Brown',
  email: 'eva@gadgetworld.com',
  phone: '+1 (555) 876-5432'
}];
// Mock store data for each chain merchant
const storesData = {
  CM001: [{
    id: 'ST001',
    name: 'CityMart Downtown',
    address: '123 Main St, Downtown, NY 10001',
    status: 'active',
    transactionVolume: 85000,
    terminalCount: 4,
    lastActivity: '2023-07-15T09:30:00Z'
  }, {
    id: 'ST002',
    name: 'CityMart Uptown',
    address: '456 Park Ave, Uptown, NY 10002',
    status: 'active',
    transactionVolume: 72000,
    terminalCount: 3,
    lastActivity: '2023-07-14T15:45:00Z'
  }, {
    id: 'ST003',
    name: 'CityMart Midtown',
    address: '789 Broadway, Midtown, NY 10003',
    status: 'inactive',
    transactionVolume: 45000,
    terminalCount: 2,
    lastActivity: '2023-07-10T11:20:00Z'
  }],
  CM002: [{
    id: 'ST004',
    name: 'HomeGoods Plus North',
    address: '101 North Blvd, North Side, NY 10004',
    status: 'active',
    transactionVolume: 95000,
    terminalCount: 5,
    lastActivity: '2023-07-15T10:15:00Z'
  }, {
    id: 'ST005',
    name: 'HomeGoods Plus South',
    address: '202 South St, South Side, NY 10005',
    status: 'active',
    transactionVolume: 88000,
    terminalCount: 4,
    lastActivity: '2023-07-14T16:30:00Z'
  }],
  CM003: [{
    id: 'ST006',
    name: 'Quick Burger - Times Square',
    address: '123 Times Square, NY 10006',
    status: 'active',
    transactionVolume: 65000,
    terminalCount: 3,
    lastActivity: '2023-07-16T12:30:00Z'
  }, {
    id: 'ST007',
    name: 'Quick Burger - Central Park',
    address: '456 Central Park West, NY 10007',
    status: 'active',
    transactionVolume: 58000,
    terminalCount: 2,
    lastActivity: '2023-07-15T14:20:00Z'
  }, {
    id: 'ST008',
    name: 'Quick Burger - Brooklyn',
    address: '789 Brooklyn Ave, Brooklyn, NY 11201',
    status: 'pending',
    transactionVolume: 0,
    terminalCount: 2,
    lastActivity: '2023-07-14T09:45:00Z'
  }]
};
// Mock super merchants for dropdown
const superMerchantsOptions = [{
  id: 'SM001',
  name: 'Global Retail Group'
}, {
  id: 'SM002',
  name: 'Fast Food Alliance'
}, {
  id: 'SM003',
  name: 'Tech Distribution Network'
}, {
  id: 'SM004',
  name: 'Hospitality Group International'
}, {
  id: 'SM005',
  name: 'Urban Transport Consortium'
}];
interface ChainMerchant {
  id: string;
  name: string;
  businessType: string;
  taxId: string;
  status: string;
  superMerchant: string;
  superMerchantId: string;
  storeCount: number;
  transactionVolume: number;
  lastActivity: string;
  contactPerson: string;
  email: string;
  phone: string;
}
interface Store {
  id: string;
  name: string;
  address: string;
  status: string;
  transactionVolume: number;
  terminalCount: number;
  lastActivity: string;
}
const ChainMerchantSetup: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedChainId = queryParams.get('id');
  const [chainMerchants, setChainMerchants] = useState<ChainMerchant[]>(chainMerchantsData);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedChainMerchant, setSelectedChainMerchant] = useState<ChainMerchant | null>(selectedChainId ? chainMerchantsData.find(m => m.id === selectedChainId) || null : null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showAddStoreModal, setShowAddStoreModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewingStores, setViewingStores] = useState(!!selectedChainId);
  // Form state for add/edit modal
  const [formData, setFormData] = useState<Partial<ChainMerchant>>({
    name: '',
    businessType: '',
    taxId: '',
    status: 'active',
    superMerchantId: '',
    contactPerson: '',
    email: '',
    phone: ''
  });
  // Form state for add store modal
  const [storeFormData, setStoreFormData] = useState<Partial<Store>>({
    name: '',
    address: '',
    status: 'active'
  });
  const handleAddChainMerchant = () => {
    setIsEditing(false);
    setFormData({
      name: '',
      businessType: '',
      taxId: '',
      status: 'active',
      superMerchantId: '',
      contactPerson: '',
      email: '',
      phone: ''
    });
    setShowAddEditModal(true);
  };
  const handleEditChainMerchant = (merchant: ChainMerchant) => {
    setIsEditing(true);
    setFormData({
      ...merchant
    });
    setShowAddEditModal(true);
  };
  const handleDeleteChainMerchant = (merchant: ChainMerchant) => {
    setSelectedChainMerchant(merchant);
    setShowDeleteModal(true);
  };
  const handleViewChainMerchant = (merchant: ChainMerchant) => {
    setSelectedChainMerchant(merchant);
    setShowViewModal(true);
  };
  const handleViewStores = (merchant: ChainMerchant) => {
    setSelectedChainMerchant(merchant);
    setViewingStores(true);
    navigate(`/chain-merchants?id=${merchant.id}`);
  };
  const handleBackToChainList = () => {
    setViewingStores(false);
    setSelectedChainMerchant(null);
    navigate('/chain-merchants');
  };
  const handleAddStore = () => {
    setStoreFormData({
      name: '',
      address: '',
      status: 'active'
    });
    setShowAddStoreModal(true);
  };
  const handleBulkUpload = () => {
    setShowBulkUploadModal(true);
  };
  const confirmDelete = () => {
    if (selectedChainMerchant) {
      setChainMerchants(chainMerchants.filter(m => m.id !== selectedChainMerchant.id));
      setShowDeleteModal(false);
      setSelectedChainMerchant(null);
      if (viewingStores) {
        setViewingStores(false);
        navigate('/chain-merchants');
      }
    }
  };
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleStoreFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setStoreFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmitForm = () => {
    if (isEditing && selectedChainMerchant) {
      // Update existing chain merchant
      const updatedMerchants = chainMerchants.map(m => m.id === selectedChainMerchant.id ? {
        ...m,
        ...formData,
        storeCount: m.storeCount,
        transactionVolume: m.transactionVolume,
        lastActivity: m.lastActivity,
        superMerchant: superMerchantsOptions.find(sm => sm.id === formData.superMerchantId)?.name || m.superMerchant
      } : m);
      setChainMerchants(updatedMerchants);
      if (viewingStores) {
        setSelectedChainMerchant(updatedMerchants.find(m => m.id === selectedChainMerchant.id) || null);
      }
    } else {
      // Add new chain merchant
      const superMerchantInfo = superMerchantsOptions.find(sm => sm.id === formData.superMerchantId);
      const newChainMerchant: ChainMerchant = {
        id: `CM${String(chainMerchants.length + 1).padStart(3, '0')}`,
        name: formData.name || '',
        businessType: formData.businessType || '',
        taxId: formData.taxId || '',
        status: formData.status || 'active',
        superMerchantId: formData.superMerchantId || '',
        superMerchant: superMerchantInfo?.name || 'Unassigned',
        storeCount: 0,
        transactionVolume: 0,
        lastActivity: new Date().toISOString(),
        contactPerson: formData.contactPerson || '',
        email: formData.email || '',
        phone: formData.phone || ''
      };
      setChainMerchants([...chainMerchants, newChainMerchant]);
    }
    setShowAddEditModal(false);
  };
  const handleSubmitStoreForm = () => {
    if (selectedChainMerchant) {
      // In a real app, you would update the store data in the backend
      console.log(`Adding store to ${selectedChainMerchant.name}:`, storeFormData);
      const updatedMerchants = chainMerchants.map(m => m.id === selectedChainMerchant.id ? {
        ...m,
        storeCount: m.storeCount + 1,
        lastActivity: new Date().toISOString()
      } : m);
      setChainMerchants(updatedMerchants);
      setSelectedChainMerchant(updatedMerchants.find(m => m.id === selectedChainMerchant.id) || null);
    }
    setShowAddStoreModal(false);
  };
  const handleExport = (format: 'csv' | 'xlsx' | 'pdf') => {
    console.log(`Exporting ${viewingStores ? 'stores' : 'chain merchants'} as ${format}`);
  };
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <StatusBadge status="success" text="Active" data-id="element-994" />;
      case 'inactive':
        return <StatusBadge status="danger" text="Inactive" data-id="element-995" />;
      case 'pending':
        return <StatusBadge status="warning" text="Pending" data-id="element-996" />;
      default:
        return <StatusBadge status="default" text={status} data-id="element-997" />;
    }
  };
  const chainMerchantColumns = [{
    header: 'Chain Merchant',
    accessor: (merchant: ChainMerchant) => <div data-id="element-998">
          <div className="font-medium" data-id="element-999">{merchant.name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1000">
            {merchant.id}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Business Type',
    accessor: 'businessType',
    sortable: true
  }, {
    header: 'Super Merchant',
    accessor: 'superMerchant',
    sortable: true
  }, {
    header: 'Status',
    accessor: (merchant: ChainMerchant) => getStatusBadge(merchant.status),
    sortable: false
  }, {
    header: 'Store Count',
    accessor: 'storeCount',
    sortable: true
  }, {
    header: 'Transaction Volume',
    accessor: (merchant: ChainMerchant) => formatCurrency(merchant.transactionVolume),
    sortable: true
  }];
  const storeColumns = [{
    header: 'Store',
    accessor: (store: Store) => <div data-id="element-1001">
          <div className="font-medium" data-id="element-1002">{store.name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1003">
            {store.id}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Address',
    accessor: 'address',
    sortable: true
  }, {
    header: 'Status',
    accessor: (store: Store) => getStatusBadge(store.status),
    sortable: false
  }, {
    header: 'Terminals',
    accessor: 'terminalCount',
    sortable: true
  }, {
    header: 'Transaction Volume',
    accessor: (store: Store) => formatCurrency(store.transactionVolume),
    sortable: true
  }, {
    header: 'Last Activity',
    accessor: (store: Store) => formatDateTime(store.lastActivity),
    sortable: true
  }];
  const filteredChainMerchants = chainMerchants.filter(merchant => merchant.name.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.id.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.businessType.toLowerCase().includes(searchQuery.toLowerCase()) || merchant.superMerchant.toLowerCase().includes(searchQuery.toLowerCase()));
  const currentStores = selectedChainMerchant ? storesData[selectedChainMerchant.id] || [] : [];
  return <div className="space-y-6" data-id="element-1004">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-1005">
        {viewingStores && selectedChainMerchant ? <>
            <div data-id="element-1006">
              <button onClick={handleBackToChainList} className="inline-flex items-center text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" data-id="element-1007">
                <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-1008" />
                Back to Chain Merchants
              </button>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-1" data-id="element-1009">
                {selectedChainMerchant.name} Stores
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-1010">
                Manage stores for {selectedChainMerchant.name} (
                {selectedChainMerchant.id})
              </p>
            </div>
            <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-1011">
              <button onClick={handleBulkUpload} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1012">
                <UploadIcon className="h-4 w-4 mr-2" data-id="element-1013" />
                Bulk Upload
              </button>
              <ExportMenu onExport={handleExport} data-id="element-1014" />
              <button onClick={handleAddStore} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1015">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-1016" />
                Add Store
              </button>
            </div>
          </> : <>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1017">
              Chain Merchant Setup
            </h1>
            <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-1018">
              <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1019">
                <FilterIcon className="h-4 w-4 mr-2" data-id="element-1020" />
                Filters
              </button>
              <ExportMenu onExport={handleExport} data-id="element-1021" />
              <button onClick={handleAddChainMerchant} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1022">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-1023" />
                Add Chain Merchant
              </button>
            </div>
          </>}
      </div>

      {/* Dashboard Cards - Only show when viewing stores */}
      {viewingStores && selectedChainMerchant && <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1024">
          <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800" data-id="element-1025">
            <div className="flex items-center" data-id="element-1026">
              <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-800 mr-4" data-id="element-1027">
                <MapPinIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" data-id="element-1028" />
              </div>
              <div data-id="element-1029">
                <p className="text-sm font-medium text-blue-600 dark:text-blue-400" data-id="element-1030">
                  Total Stores
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1031">
                  {selectedChainMerchant.storeCount}
                </p>
              </div>
            </div>
          </Card>
          <Card className="bg-green-50 dark:bg-green-900/20 border-green-100 dark:border-green-800" data-id="element-1032">
            <div className="flex items-center" data-id="element-1033">
              <div className="p-3 rounded-full bg-green-100 dark:bg-green-800 mr-4" data-id="element-1034">
                <TagIcon className="h-6 w-6 text-green-600 dark:text-green-400" data-id="element-1035" />
              </div>
              <div data-id="element-1036">
                <p className="text-sm font-medium text-green-600 dark:text-green-400" data-id="element-1037">
                  Active Stores
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1038">
                  {currentStores.filter(store => store.status === 'active').length}
                </p>
              </div>
            </div>
          </Card>
          <Card className="bg-purple-50 dark:bg-purple-900/20 border-purple-100 dark:border-purple-800" data-id="element-1039">
            <div className="flex items-center" data-id="element-1040">
              <div className="p-3 rounded-full bg-purple-100 dark:bg-purple-800 mr-4" data-id="element-1041">
                <QrCodeIcon className="h-6 w-6 text-purple-600 dark:text-purple-400" data-id="element-1042" />
              </div>
              <div data-id="element-1043">
                <p className="text-sm font-medium text-purple-600 dark:text-purple-400" data-id="element-1044">
                  Total Terminals
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1045">
                  {currentStores.reduce((sum, store) => sum + store.terminalCount, 0)}
                </p>
              </div>
            </div>
          </Card>
          <Card className="bg-amber-50 dark:bg-amber-900/20 border-amber-100 dark:border-amber-800" data-id="element-1046">
            <div className="flex items-center" data-id="element-1047">
              <div className="p-3 rounded-full bg-amber-100 dark:bg-amber-800 mr-4" data-id="element-1048">
                <DownloadIcon className="h-6 w-6 text-amber-600 dark:text-amber-400" data-id="element-1049" />
              </div>
              <div data-id="element-1050">
                <p className="text-sm font-medium text-amber-600 dark:text-amber-400" data-id="element-1051">
                  Transaction Volume
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1052">
                  {formatCurrency(currentStores.reduce((sum, store) => sum + store.transactionVolume, 0))}
                </p>
              </div>
            </div>
          </Card>
        </div>}

      {/* Search and Filters */}
      <div className="flex flex-col md:flex-row gap-4" data-id="element-1053">
        <div className="relative flex-grow" data-id="element-1054">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1055">
            <SearchIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-1056" />
          </div>
          <input type="text" className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-md block w-full pl-10 p-2.5" placeholder={viewingStores ? 'Search stores...' : 'Search by name, ID, or business type...'} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1057" />
        </div>
      </div>

      {showFilters && !viewingStores && <Card data-id="element-1058">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1059">
            <div data-id="element-1060">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1061">
                Status
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-1062">
                <option value="" data-id="element-1063">All Statuses</option>
                <option value="active" data-id="element-1064">Active</option>
                <option value="inactive" data-id="element-1065">Inactive</option>
                <option value="pending" data-id="element-1066">Pending</option>
              </select>
            </div>
            <div data-id="element-1067">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1068">
                Business Type
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-1069">
                <option value="" data-id="element-1070">All Types</option>
                <option value="Retail" data-id="element-1071">Retail</option>
                <option value="Food & Beverage" data-id="element-1072">Food & Beverage</option>
                <option value="Technology" data-id="element-1073">Technology</option>
                <option value="Home Improvement" data-id="element-1074">Home Improvement</option>
              </select>
            </div>
            <div data-id="element-1075">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1076">
                Super Merchant
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-1077">
                <option value="" data-id="element-1078">All Super Merchants</option>
                {superMerchantsOptions.map(sm => <option key={sm.id} value={sm.id} data-id="element-1079">
                    {sm.name}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-3" data-id="element-1080">
            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1081">
              Reset
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1082">
              Apply Filters
            </button>
          </div>
        </Card>}

      <Card data-id="element-1083">
        {viewingStores && selectedChainMerchant ? <Table columns={storeColumns} data={currentStores} keyField="id" actions={store => <div className="flex justify-end space-x-2" data-id="element-1085">
                <button className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-1086">
                  <EyeIcon className="h-5 w-5" data-id="element-1087" />
                </button>
                <button className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-1088">
                  <EditIcon className="h-5 w-5" data-id="element-1089" />
                </button>
                <button className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-1090">
                  <TrashIcon className="h-5 w-5" data-id="element-1091" />
                </button>
              </div>} data-id="element-1084" /> : <Table columns={chainMerchantColumns} data={filteredChainMerchants} keyField="id" actions={merchant => <div className="flex justify-end space-x-2" data-id="element-1093">
                <button onClick={() => handleViewChainMerchant(merchant)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-1094">
                  <EyeIcon className="h-5 w-5" data-id="element-1095" />
                </button>
                <button onClick={() => handleViewStores(merchant)} className="p-1 rounded-full text-purple-600 dark:text-purple-400 hover:bg-purple-100 dark:hover:bg-purple-900/30" title="View Stores" data-id="element-1096">
                  <MapPinIcon className="h-5 w-5" data-id="element-1097" />
                </button>
                <button onClick={() => handleEditChainMerchant(merchant)} className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-1098">
                  <EditIcon className="h-5 w-5" data-id="element-1099" />
                </button>
                <button onClick={() => handleDeleteChainMerchant(merchant)} className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-1100">
                  <TrashIcon className="h-5 w-5" data-id="element-1101" />
                </button>
              </div>} data-id="element-1092" />}
      </Card>

      {/* View Chain Merchant Modal */}
      <Modal isOpen={showViewModal} onClose={() => setShowViewModal(false)} title="Chain Merchant Details" size="lg" data-id="element-1102">
        {selectedChainMerchant && <div className="space-y-6" data-id="element-1103">
            <div className="flex items-center" data-id="element-1104">
              <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-800 mr-4" data-id="element-1105">
                <BuildingIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" data-id="element-1106" />
              </div>
              <div data-id="element-1107">
                <h3 className="text-lg font-medium" data-id="element-1108">
                  {selectedChainMerchant.name}
                </h3>
                <div className="flex items-center mt-1" data-id="element-1109">
                  {getStatusBadge(selectedChainMerchant.status)}
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-1110">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1111">
                    {selectedChainMerchant.businessType}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1112">
              <div data-id="element-1113">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-1114">
                  Chain Merchant Information
                </h4>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2" data-id="element-1115">
                  <div className="flex justify-between" data-id="element-1116">
                    <span className="text-sm font-medium" data-id="element-1117">ID:</span>
                    <span className="text-sm" data-id="element-1118">{selectedChainMerchant.id}</span>
                  </div>
                  <div className="flex justify-between" data-id="element-1119">
                    <span className="text-sm font-medium" data-id="element-1120">Tax ID:</span>
                    <span className="text-sm" data-id="element-1121">
                      {selectedChainMerchant.taxId}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1122">
                    <span className="text-sm font-medium" data-id="element-1123">Super Merchant:</span>
                    <span className="text-sm" data-id="element-1124">
                      {selectedChainMerchant.superMerchant}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1125">
                    <span className="text-sm font-medium" data-id="element-1126">Store Count:</span>
                    <span className="text-sm" data-id="element-1127">
                      {selectedChainMerchant.storeCount}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1128">
                    <span className="text-sm font-medium" data-id="element-1129">
                      Transaction Volume:
                    </span>
                    <span className="text-sm" data-id="element-1130">
                      {formatCurrency(selectedChainMerchant.transactionVolume)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1131">
                    <span className="text-sm font-medium" data-id="element-1132">Last Activity:</span>
                    <span className="text-sm" data-id="element-1133">
                      {formatDateTime(selectedChainMerchant.lastActivity)}
                    </span>
                  </div>
                </div>
              </div>
              <div data-id="element-1134">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3" data-id="element-1135">
                  Contact Information
                </h4>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2" data-id="element-1136">
                  <div className="flex justify-between" data-id="element-1137">
                    <span className="text-sm font-medium" data-id="element-1138">Contact Person:</span>
                    <span className="text-sm" data-id="element-1139">
                      {selectedChainMerchant.contactPerson}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1140">
                    <span className="text-sm font-medium" data-id="element-1141">Email:</span>
                    <span className="text-sm" data-id="element-1142">
                      {selectedChainMerchant.email}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-1143">
                    <span className="text-sm font-medium" data-id="element-1144">Phone:</span>
                    <span className="text-sm" data-id="element-1145">
                      {selectedChainMerchant.phone}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-1146">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-1147">
                Quick Actions
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-1148">
                <button onClick={() => {
              setShowViewModal(false);
              handleViewStores(selectedChainMerchant);
            }} className="px-3 py-1 bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 rounded-md text-sm" data-id="element-1149">
                  View Stores
                </button>
                <button className="px-3 py-1 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300 rounded-md text-sm" data-id="element-1150">
                  Generate QR Codes
                </button>
                <button className="px-3 py-1 bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 rounded-md text-sm" data-id="element-1151">
                  View Transactions
                </button>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Add/Edit Chain Merchant Modal */}
      <Modal isOpen={showAddEditModal} onClose={() => setShowAddEditModal(false)} title={isEditing ? 'Edit Chain Merchant' : 'Add Chain Merchant'} size="lg" footer={<>
            <button onClick={() => setShowAddEditModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1153">
              Cancel
            </button>
            <button onClick={handleSubmitForm} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1154">
              {isEditing ? 'Update' : 'Add'} Chain Merchant
            </button>
          </>} data-id="element-1152">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1155">
          <div className="md:col-span-2" data-id="element-1156">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1157">
              Chain Merchant Name <span className="text-red-500" data-id="element-1158">*</span>
            </label>
            <input type="text" name="name" value={formData.name || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter chain merchant name" required data-id="element-1159" />
          </div>
          <div data-id="element-1160">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1161">
              Business Type <span className="text-red-500" data-id="element-1162">*</span>
            </label>
            <select name="businessType" value={formData.businessType || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" required data-id="element-1163">
              <option value="" data-id="element-1164">Select Business Type</option>
              <option value="Retail" data-id="element-1165">Retail</option>
              <option value="Food & Beverage" data-id="element-1166">Food & Beverage</option>
              <option value="Technology" data-id="element-1167">Technology</option>
              <option value="Home Improvement" data-id="element-1168">Home Improvement</option>
              <option value="Hospitality" data-id="element-1169">Hospitality</option>
              <option value="Healthcare" data-id="element-1170">Healthcare</option>
              <option value="Education" data-id="element-1171">Education</option>
              <option value="Entertainment" data-id="element-1172">Entertainment</option>
            </select>
          </div>
          <div data-id="element-1173">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1174">
              Tax ID <span className="text-red-500" data-id="element-1175">*</span>
            </label>
            <input type="text" name="taxId" value={formData.taxId || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter tax ID" required data-id="element-1176" />
          </div>
          <div data-id="element-1177">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1178">
              Super Merchant <span className="text-red-500" data-id="element-1179">*</span>
            </label>
            <select name="superMerchantId" value={formData.superMerchantId || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" required data-id="element-1180">
              <option value="" data-id="element-1181">Select Super Merchant</option>
              {superMerchantsOptions.map(sm => <option key={sm.id} value={sm.id} data-id="element-1182">
                  {sm.name}
                </option>)}
            </select>
          </div>
          <div data-id="element-1183">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1184">
              Contact Person <span className="text-red-500" data-id="element-1185">*</span>
            </label>
            <input type="text" name="contactPerson" value={formData.contactPerson || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter contact person name" required data-id="element-1186" />
          </div>
          <div data-id="element-1187">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1188">
              Status
            </label>
            <select name="status" value={formData.status || 'active'} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-1189">
              <option value="active" data-id="element-1190">Active</option>
              <option value="inactive" data-id="element-1191">Inactive</option>
              <option value="pending" data-id="element-1192">Pending</option>
            </select>
          </div>
          <div data-id="element-1193">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1194">
              Email <span className="text-red-500" data-id="element-1195">*</span>
            </label>
            <input type="email" name="email" value={formData.email || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter email address" required data-id="element-1196" />
          </div>
          <div data-id="element-1197">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1198">
              Phone <span className="text-red-500" data-id="element-1199">*</span>
            </label>
            <input type="tel" name="phone" value={formData.phone || ''} onChange={handleFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter phone number" required data-id="element-1200" />
          </div>
        </div>
      </Modal>

      {/* Add Store Modal */}
      <Modal isOpen={showAddStoreModal} onClose={() => setShowAddStoreModal(false)} title="Add Store" size="md" footer={<>
            <button onClick={() => setShowAddStoreModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1202">
              Cancel
            </button>
            <button onClick={handleSubmitStoreForm} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1203">
              Add Store
            </button>
          </>} data-id="element-1201">
        <div className="space-y-4" data-id="element-1204">
          <div data-id="element-1205">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1206">
              Store Name <span className="text-red-500" data-id="element-1207">*</span>
            </label>
            <input type="text" name="name" value={storeFormData.name || ''} onChange={handleStoreFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter store name" required data-id="element-1208" />
          </div>
          <div data-id="element-1209">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1210">
              Address <span className="text-red-500" data-id="element-1211">*</span>
            </label>
            <textarea name="address" value={storeFormData.address || ''} onChange={handleStoreFormChange} rows={3} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Enter store address" required data-id="element-1212" />
          </div>
          <div data-id="element-1213">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1214">
              Status
            </label>
            <select name="status" value={storeFormData.status || 'active'} onChange={handleStoreFormChange} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-1215">
              <option value="active" data-id="element-1216">Active</option>
              <option value="inactive" data-id="element-1217">Inactive</option>
              <option value="pending" data-id="element-1218">Pending</option>
            </select>
          </div>
          <div className="flex items-start mt-4" data-id="element-1219">
            <InfoIcon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-1220" />
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-1221">
              After adding the store, you can configure terminals, payment
              methods, and transaction limits.
            </p>
          </div>
        </div>
      </Modal>

      {/* Bulk Upload Modal */}
      <Modal isOpen={showBulkUploadModal} onClose={() => setShowBulkUploadModal(false)} title="Bulk Upload Stores" size="md" data-id="element-1222">
        <div className="space-y-4" data-id="element-1223">
          <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-1224">
            Upload a CSV or Excel file containing multiple stores to add them in
            bulk. Please ensure your file follows the required format.
          </p>
          <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md px-6 pt-5 pb-6" data-id="element-1225">
            <div className="space-y-2 text-center" data-id="element-1226">
              <UploadIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1227" />
              <div className="flex text-sm text-gray-600 dark:text-gray-400" data-id="element-1228">
                <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white dark:bg-gray-800 font-medium text-blue-600 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300 focus-within:outline-none" data-id="element-1229">
                  <span data-id="element-1230">Upload a file</span>
                  <input id="file-upload" name="file-upload" type="file" className="sr-only" data-id="element-1231" />
                </label>
                <p className="pl-1" data-id="element-1232">or drag and drop</p>
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1233">
                CSV, XLSX up to 10MB
              </p>
            </div>
          </div>
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3" data-id="element-1234">
            <h4 className="text-sm font-medium text-blue-800 dark:text-blue-300 flex items-center" data-id="element-1235">
              <InfoIcon className="h-4 w-4 mr-2" data-id="element-1236" />
              Template Format
            </h4>
            <p className="mt-1 text-sm text-blue-700 dark:text-blue-400" data-id="element-1237">
              Your file should include columns for Store Name, Address, Status,
              and any additional store information.
            </p>
            <div className="mt-2" data-id="element-1238">
              <a href="#" className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline" data-id="element-1239">
                Download Template
              </a>
            </div>
          </div>
          <div className="flex justify-end space-x-3 mt-4" data-id="element-1240">
            <button onClick={() => setShowBulkUploadModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1241">
              Cancel
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-1242">
              Upload and Process
            </button>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} title="Confirm Deletion" footer={<>
            <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1244">
              Cancel
            </button>
            <button onClick={confirmDelete} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-1245">
              Delete
            </button>
          </>} data-id="element-1243">
        <div className="space-y-4" data-id="element-1246">
          <p className="text-gray-700 dark:text-gray-300" data-id="element-1247">
            Are you sure you want to delete the chain merchant "
            {selectedChainMerchant?.name}"? This action cannot be undone.
          </p>
          {selectedChainMerchant && selectedChainMerchant.storeCount > 0 && <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md p-3 text-sm text-yellow-800 dark:text-yellow-300" data-id="element-1248">
              <p className="font-medium" data-id="element-1249">
                Warning: This chain merchant has{' '}
                {selectedChainMerchant.storeCount} stores
              </p>
              <p className="mt-1" data-id="element-1250">
                Deleting this chain merchant will also delete all associated
                stores and their transaction history.
              </p>
            </div>}
        </div>
      </Modal>
    </div>;
};
export default ChainMerchantSetup;